export const TabInput = (labelId, index) => `<input type="radio" id="tab-slider-${labelId}" name="tabs-slider-${index}" />`;